export default "__VITE_ASSET__BcJ1uPaE__"